/* ============================================================================
   IFS CUSTOM PARALLAX — assets/custom-parallax.js
   Gentle vertical parallax for [data-ifh-parallax] photo bands.
   Off for reduced-motion users and on small screens.
   ========================================================================== */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  var items = [];
  var ticking = false;

  function collect() {
    items = [];
    var els = document.querySelectorAll('[data-ifh-parallax]');
    for (var i = 0; i < els.length; i++) {
      var img = els[i].querySelector('.ifh-photo__img');
      if (img) items.push({ el: els[i], img: img });
    }
  }
  function update() {
    ticking = false;
    if (window.innerWidth < 768) {
      for (var j = 0; j < items.length; j++) items[j].img.style.transform = '';
      return;
    }
    var vh = window.innerHeight;
    for (var i = 0; i < items.length; i++) {
      var r = items[i].el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) continue;
      var progress = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      var shift = Math.max(-1, Math.min(1, progress)) * (r.height * 0.12);
      items[i].img.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
    }
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }
  function boot() {
    collect();
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', boot);
})();
